const EnterpriseList = () => import(
  /* webpackChunkName: "EnterpriseList" */
  './EnterpriseList');
const SystemAdminList = () => import(
  /* webpackChunkName: "SystemAdminList" */
  './SystemAdminList');
const SystemSetting = () => import(
  /* webpackChunkName: "SystemSetting" */
  './SystemSetting');
const ModelManagement = () => import(
  /* webpackChunkName: "ModelManageView" */
  './ModelManageView');

export default {
  pages: [
    {
      path: 'enterprise-manage',
      name: 'enterprise-manage',
      component: EnterpriseList,
    },
    {
      name: 'system-admin-list',
      path: 'system-admin-list',
      component: SystemAdminList,
    },
    {
      path: 'system-setting',
      name: 'system-setting',
      component: SystemSetting,
    },
    {
      path: 'model-manage',
      name: 'model-manage',
      component: ModelManagement,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/manage-modules/SystemManage/index.js